import React from "react";
import styles from "./styles.module.scss";
import { TContentWithImage } from "@page-builder/ts/generated";
import { useDomainContext } from "@hooks/useDomainContext";
import { replacePlaceholders } from "@lib/sharedUtils";
import { useRouter } from "next/router";
import { gettingQueriesAsString } from "@lib/shared/routerQueriesToString";
import { ResponsiveImageRenderer } from "@page-builder/utils/index";

const ContentWithImage = ({
    props = {},
}: {
    props: TContentWithImage["props"];
}) => {
    const { query } = useRouter();
    const {
        text,
        image,
        buttonText,
        withScrollButton,
        buttonIconInput,
        showButtonIcon,
    } = props;
    const scrollToTop = () => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    };
    const { category, visitDetails, routeConfig, formattedTitle } =
        useDomainContext();
    const genericRoute = routeConfig?.replacedPortions?.find(
        (portion) => portion.key === "[generic-route]",
    )?.value;
    const keyword = routeConfig?.replacedPortions?.find(
        (portion) => portion.key === "[keyword]",
    )?.value;

    const queryString = gettingQueriesAsString(query, "inline", ["slug"]);

    const showButtonIconEl = buttonIconInput && showButtonIcon;

    const buttonIconEl = (
        <span className="buttonIcon">
            <img src={buttonIconInput ?? ""} alt={`Button Icon`} />
        </span>
    );

    return (
        <section className={styles["content-with-image-container-preview"]}>
            <div className={styles.contentContainer}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: text
                            ? replacePlaceholders(text, {
                                  category: category?.name,
                                  region: visitDetails.region,
                                  city: visitDetails?.city,
                                  genericRoute,
                                  keyword,
                                  title:
                                      formattedTitle ??
                                      category?.config
                                          ?.nativeNetworksPageTitleFallback ??
                                      "",
                                  queryString: queryString,
                              })
                            : "",
                    }}
                    className={`prose md:prose-md max-w-none ${styles["text-block"]}`}
                />
                {withScrollButton && (
                    <button
                        className={`${
                            styles.scrollToTopPreview
                        } text-sm sm:text-lg ${
                            buttonIconInput ? styles.withIcon : ""
                        }`}
                        onClick={() => scrollToTop()}
                    >
                        {showButtonIconEl && buttonIconEl}
                        {buttonText}
                    </button>
                )}
            </div>
            <div className={styles.imageContainer}>
                {image ? <ResponsiveImageRenderer image={image} /> : null}
            </div>
        </section>
    );
};

export default ContentWithImage;
